import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
interface InlinePopoverProps {
  ariaLabel: string;
  trigger: React.ReactNode;
  triggerClassName?: string;
  align?: 'left' | 'right' | 'center';
  children: (close: () => void) => React.ReactNode;
}
const alignClass = {
  left: 'left-0',
  right: 'right-0',
  center: 'left-1/2 -translate-x-1/2'
};
export function InlinePopover({
  ariaLabel,
  trigger,
  triggerClassName = '',
  align = 'left',
  children
}: InlinePopoverProps) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && setOpen(false);
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);
  return <div ref={ref} className="relative" data-id="element-220" data-mp="3g1yewir5qne9">
      <button type="button" aria-label={ariaLabel} aria-haspopup="listbox" aria-expanded={open} onClick={() => setOpen(v => !v)} className={`rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-brand ${triggerClassName}`} data-id="element-221" data-mp="3g316kswb0tv8">
        {trigger}
      </button>
      <AnimatePresence data-id="element-222" data-mp="2uo8z742u54m">
        {open && <motion.div initial={{
        opacity: 0,
        y: -4
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -4
      }} transition={{
        duration: 0.12
      }} className={`absolute top-full z-30 mt-1 ${alignClass[align]}`} data-id="element-223" data-mp="2tv2m7915hn0">
            {children(() => setOpen(false))}
          </motion.div>}
      </AnimatePresence>
    </div>;
}